document.addEventListener('DOMContentLoaded', ()=>{
    const announcementBar = document.querySelector('.Announcement_Bar');
    const header = document.querySelector('.Header');

    if(!announcementBar || !header) return;

    let announcementBarHeight = 0;

    function onResize(){
        announcementBarHeight = announcementBar.offsetHeight;
        // set --offset property to header
        header.style.setProperty('--offset', `${-announcementBarHeight}px`);
    }
    onResize();
    window.addEventListener('resize', onResize);

    let oldScroll = 0;

    window.addEventListener('scroll', function(e){
        // Hide announcement on scroll down and show on scroll up
        let scrollDirection = window.scrollY > oldScroll ? 'down' : 'up';

        if(scrollDirection == 'down'){
            announcementBar.classList.add('Hidden');
            header.classList.add('Up');
        } else {
            announcementBar.classList.remove('Hidden');
            header.classList.remove('Up');
        }

        oldScroll = window.scrollY;
    });
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const redDot = document.querySelector('.Cart_Has-Items');
      if (cart.item_count > 0) {
        if (!redDot) {
          const cartLink = document.querySelector('#Cart_Container');
          const newDot = document.createElement('span');
          newDot.className = 'cart-red-dot';
          cartLink.appendChild(newDot);
        }
      } else if (redDot) {
        redDot.remove();
      }

});
});